import { Platform } from '@angular/cdk/platform';
import { Component, Input, OnChanges, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { DashboardPreference } from '@onviobr/blue-dashboard';
import { has as hasAccess } from '@onviobr/services/access';
import { has as hasLicenses } from '@onviobr/services/licenses';
import { has as hasPermissions } from '@onviobr/services/permission';
import { addPreference, getPreference, patchPreference } from '@onviobr/services/preference';
import { TranslateService } from '@ngx-translate/core';

import { MFEHelperService } from './services/mfehelper.service';
import { isQedOrProdType } from '@onviobr/services/environment/constants';

@Component({
	selector: 'app-client-dashboard',
	templateUrl: './client-dashboard.component.html',
	styleUrls: ['./client-dashboard.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ClientDashboardComponent implements OnInit, OnDestroy, OnChanges {
	@Input() isLoading = true;
	@Input() isLinkedToOnBalance = false;
	@Input() isSimpleTaxPayer = false;
	@Input() background: string;
	@Input() client: cs.IClientWithExpansionV3Dto;

	public isLoadingDashboardLayout = true;
	public dashboardStyle = { opacity: 0, transition: '' };

	public licenseClientDash = false;
	public licenseOnbalanceLinking = false;
	public licenseBilling = false;
	public licenseTimeAndExpense = false;
	public licenseTasks = false;



	public accessOnBalance = false;
	public accessQuarterReport = false;
	public accessClientDashBoardCustomFields = false;

	public accessConfirmation = false;

	public accessFmDashboardCustomFieldsWidget = false;
	public hasProjectsFRP = false;
	public hasCustomFieldLicense = false;


	public preferences: DashboardPreference;
	public preferenceId: string;

	public preference = {
		getPreference,
		patchPreference,
		addPreference
	};
	public licenses = hasLicenses;
	public access = hasAccess;
	public permissions = hasPermissions;
	isEditable = false;

	constructor(
		platformService: Platform,
		private readonly translate: TranslateService,
		public mfeHelperService: MFEHelperService,
	) {
		this.isEditable = !(platformService.TRIDENT || platformService.IOS);
	}

	async ngOnInit() {
		const onBalanceLinking = await this.licenses('Onbalance.Linking');
		this.hasProjectsFRP = await this.permissions('OnvioSetup.Projects');
		this.licenseClientDash = await this.licenses('Onvio.ClientDashboard');
		this.licenseOnbalanceLinking = onBalanceLinking && !isQedOrProdType;
		this.licenseBilling = await this.licenses('TimeAndBilling.Billing');
		this.licenseTimeAndExpense = await this.licenses('TimeAndBilling.TimeAndExpense');
		this.licenseTasks = await this.licenses('ProjectManagement.Tasks');
		this.accessOnBalance = await this.access('ClientDashboard_OnBalanceAccess');
		this.accessQuarterReport = await this.access('QuarterReportStatementsWidget');
		this.accessConfirmation = await this.access('Confirmation.Experimental');
		this.accessClientDashBoardCustomFields = await this.access('setup.clientdashboard.displaycustomfields');
		this.hasCustomFieldLicense = await this.licenses('OnvioSetup.CustomFields');

		this.accessFmDashboardCustomFieldsWidget = await this.access('setup.clientdashboard.dashboardcustomfields');
		const preferences = await this.preference.getPreference('onvio', 'clientDashboard');
		if (preferences.length > 0) {
			this.preferenceId = preferences[0].id;
			this.preferences = preferences[0].value as DashboardPreference;
		}
		this.createMFEs();
		setTimeout(() => this._completeLoadingDashboard(), 3000);

		window.scrollTo(0, 0);
	}

	// Método removido - funcionalidade específica para Argentina não é mais necessária

	ngOnChanges(): void {
		// Método simplificado - funcionalidade específica para Argentina removida
	}

	// After the dashboard layout has loaded and should have manipulated the DOM, display it softly
	_completeLoadingDashboard(): void {
		this.isLoadingDashboardLayout = false;
		this.dashboardStyle = { opacity: 1, transition: 'opacity 2s' };
	}

	public async onSave(data: DashboardPreference) {
		try {
			if (this.preferenceId) {
				await this.preference.patchPreference(data, this.preferenceId);
			} else {
				await this.preference.addPreference({
					application: 'onvio',
					category: 'clientDashboard',
					value: data
				});
			}
		} catch (error) {
			console.error(error);
		}
	}

	public getClientAssignmentsWidgetHeaderText() {
		if (this.licenseTasks) {
			return this.translate.instant('Onvio.ClientDashboard.ClientAssignments.Header.ProjectsAndTasks');
		}
		return this.translate.instant('Onvio.ClientDashboard.ClientAssignments.Header.Projects');
	}

	public canShowConfirmationsWidget() {
		return this.accessConfirmation &&
			(!!this.client && this.client.primaryContactExpanded.entityType.id.toUpperCase() === 'USCCORPORATION');
	}

	public showTimeAndBillingWidgets() {
		return this.licenseTimeAndExpense || this.licenseBilling;
	}

	public createMFEs(_destroyNode = false) {
		// Removed Argentina-specific and UK-specific widgets
		// Only core functionality for BR/US remains
	}

	ngOnDestroy(): void {
		this.createMFEs(true);
	}
}
